import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { ChapterRadioButtonData, TimeTrackingMethod } from '@app/+onboarding/chapters/chapter.model';
import { OnboardingChapterModule } from '@app/+onboarding/chapters/components/chapter.module';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { RadioComponent } from '@sb/ui/radio';
import { RadioGroupComponent } from '@sb/ui/radio-group';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'time-tracking-tracking-method',
  imports: [OnboardingChapterModule, TranslatePipe, RadioComponent, RadioGroupComponent, ReactiveFormsModule],
  templateUrl: './time-tracking-tracking-method.component.html',
})
export class TimeTrackingTrackingMethodComponent {
  private translate = inject(TranslateService);

  timeTrackingMethod = new FormControl();

  timeTrackingMethods: ChapterRadioButtonData[] = [
    {
      value: TimeTrackingMethod.SELF_CLOCKING,
      label: this.translate.instant('Allow employees to clock in and out'),
      description: this.translate.instant(
        'The most hands-off option. Employees record their own hours for maximum accuracy and accountability.',
      ),
    },
    {
      value: TimeTrackingMethod.COPY_FROM_SCHEDULE,
      label: this.translate.instant('Copy shifts from your schedule'),
      description: this.translate.instant(
        'A quicker option. Timesheets are pre-filled from shifts in your schedule, great for when employees stick closely to their assigned hours.',
      ),
    },
    {
      value: TimeTrackingMethod.MANUAL,
      label: this.translate.instant('Manually track hours worked'),
      description: this.translate.instant(
        'You (or your employees) manually enter worked hours, giving you the most flexibility, but also requiring the most effort.',
      ),
    },
  ];

  @Input()
  nextButtonLoading: boolean;

  @Output()
  next = new EventEmitter<TimeTrackingMethod>();

  onNext() {
    if (this.timeTrackingMethod.value) {
      this.next.emit(this.timeTrackingMethod.value);
    }
  }
}
